module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "demo"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "sub_inner"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('train_up'))), _c('br'), _vm._v(_vm._s(_vm.$t('trade_up')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('train_text_1'))), _c('br'), _c('br'), _vm._v(_vm._s(_vm.$t('train_text_2')))]), _vm._v(" "), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.$t('train_list_item_1')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('train_list_item_2')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('train_list_item_3')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('train_list_item_4')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "step column is-6 form-column"
  }, [_c('h2', {
    staticClass: "form_title"
  }, [_vm._v(_vm._s(_vm.$t('form_title_1'))), _c('br'), _vm._v(_vm._s(_vm.$t('form_title_2')) + " "), _c('span', [_vm._v(_vm._s(_vm.$t('form_title_3').tUpper()))])]), _vm._v(" "), _c('p', {
    staticClass: "form_subtitle"
  }, [_vm._v(_vm._s(_vm.$t('form_subtitle')))]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "firstname"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.firstname))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_spaces'),
      expression: "'required|alpha_spaces'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.firstname),
      expression: "body.firstname"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('firstname')
    },
    attrs: {
      "name": "firstname",
      "type": "text",
      "data-vv-as": _vm.translations.text.firstname,
      "placeholder": _vm.translations.text.firstname
    },
    domProps: {
      "value": (_vm.body.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "firstname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('firstname')),
      expression: "errors.has('firstname')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('firstname')))])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "lastname"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.lastname))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_spaces'),
      expression: "'required|alpha_spaces'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.lastname),
      expression: "body.lastname"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('lastname')
    },
    attrs: {
      "name": "lastname",
      "type": "text",
      "data-vv-as": _vm.translations.text.lastname,
      "placeholder": _vm.translations.text.lastname
    },
    domProps: {
      "value": (_vm.body.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "lastname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('lastname')),
      expression: "errors.has('lastname')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('lastname')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.email))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email|email-available'),
      expression: "'required|email|email-available'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.email),
      expression: "body.email"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('email')
    },
    attrs: {
      "name": "email",
      "type": "text",
      "data-vv-as": _vm.translations.text.email,
      "placeholder": _vm.translations.text.email
    },
    domProps: {
      "value": (_vm.body.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "country"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.country) + "/" + _vm._s(_vm.$t('region')))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select is-fullwidth custom_select"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.country),
      expression: "body.country"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('country')
    },
    attrs: {
      "required": "",
      "data-vv-as": _vm.translations.text.country,
      "name": "country"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.checkIfIsEuropeanCountry]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.filteredCountries), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "select_placeholder"
  }, [_vm._v(_vm._s(_vm.translations.text.country))])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('country')),
      expression: "errors.has('country')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('country')))])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.phone))]), _vm._v(" "), _c('div', {
    staticClass: "control relative"
  }, [_c('div', {
    staticClass: "dialcodeBox"
  }, [_vm._v(_vm._s(_vm.body.country != '' ? _vm.body.dialCode : ''))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.phone),
      expression: "body.phone"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('phone'), 'push-left': _vm.body.country != ''
    },
    attrs: {
      "name": "phone",
      "type": "text",
      "data-vv-as": _vm.translations.text.phone,
      "placeholder": _vm.translations.text.phone
    },
    domProps: {
      "value": (_vm.body.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('phone')),
      expression: "errors.has('phone')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('phone')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "walletCurrency"
    }
  }, [_vm._v(_vm._s(_vm.$t("wallet_currency")))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select is-fullwidth custom_select"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.walletCurrency),
      expression: "body.walletCurrency"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('walletCurrency')
    },
    attrs: {
      "required": "",
      "data-vv-as": _vm.translations.text.walletCurrency,
      "name": "walletCurrency"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body, "walletCurrency", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$getCurrencies()), function(c, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v(_vm._s(i) + " (" + _vm._s(c.symbol) + ")")])
  }), 0), _vm._v(" "), _c('span', {
    staticClass: "select_placeholder"
  }, [_vm._v(_vm._s(_vm.$t('select_currency_label')))])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('currency')),
      expression: "errors.has('currency')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('currency')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.password))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|strong-password|confirmed:confirm_password'),
      expression: "'required|strong-password|confirmed:confirm_password'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.password),
      expression: "body.password"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('password')
    },
    attrs: {
      "name": "password",
      "type": "password",
      "data-vv-as": _vm.translations.text.password,
      "placeholder": _vm.translations.text.password
    },
    domProps: {
      "value": (_vm.body.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('password')))])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "confirm_password"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.confirm_password))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.confirm_password),
      expression: "body.confirm_password"
    }],
    ref: "confirm_password",
    class: {
      'input': true, 'is-danger': _vm.errors.has('confirm_password')
    },
    attrs: {
      "name": "confirm_password",
      "type": "password",
      "data-vv-as": _vm.translations.text.confirm_password,
      "placeholder": _vm.translations.text.confirm_password
    },
    domProps: {
      "value": (_vm.body.confirm_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "confirm_password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('confirm_password')),
      expression: "errors.has('confirm_password')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('confirm_password')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "control",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (''),
      expression: "''"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.tos_with_link),
      expression: "body.tos_with_link"
    }],
    staticClass: "agreements",
    class: {
      'is-danger': _vm.errors.has('include_account_in_bonus_program')
    },
    attrs: {
      "name": "tos_with_link",
      "type": "checkbox",
      "data-vv-as": _vm.translations.text.tos_with_link
    },
    domProps: {
      "checked": Array.isArray(_vm.body.tos_with_link) ? _vm._i(_vm.body.tos_with_link, null) > -1 : (_vm.body.tos_with_link)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.body.tos_with_link,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.body, "tos_with_link", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.body, "tos_with_link", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.body, "tos_with_link", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.translations.text.tos_with_link)
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tos_with_link')),
      expression: "errors.has('tos_with_link')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('tos_with_link')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.agree_terms_marketing),
      expression: "body.agree_terms_marketing"
    }],
    staticClass: "agreements",
    class: {
      'is-danger': _vm.errors.has('agree_terms_marketing')
    },
    attrs: {
      "name": "agree_terms_marketing",
      "type": "checkbox",
      "data-vv-as": _vm.translations.text.agree_terms_marketing
    },
    domProps: {
      "checked": Array.isArray(_vm.body.agree_terms_marketing) ? _vm._i(_vm.body.agree_terms_marketing, null) > -1 : (_vm.body.agree_terms_marketing)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.body.agree_terms_marketing,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.body, "agree_terms_marketing", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.body, "agree_terms_marketing", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.body, "agree_terms_marketing", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.translations.text.agree_terms_marketing)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "control privacy_data_text",
    domProps: {
      "innerHTML": _vm._s(_vm.translations.text.data_policy_text)
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "form_button",
    class: [_vm.isDisabled ? 'disabledButton' : ''],
    attrs: {
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.validateCaptcha
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('join').tUpper()))])])]), _vm._v(" "), (_vm.showEUNoticeModal) ? _c('div', {
    staticClass: "modal small EUModal",
    class: {
      'is-active': _vm.showEUNoticeModal
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card"
  }, [_c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('important_information')))]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('important_information_text')))])])])]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "https://my.eurotrader.eu/en/register/demo"
    }
  }, [_vm._v(_vm._s(_vm.$t('continue').tTitle()))])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0349a01a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/register/Demo.vue
// module id = 711
// module chunks = 0